import 'aos/dist/aos.css';
import AOS from 'aos';

export const onInitialClientRender = () => {
  AOS.init({
    duration: 800, // czas trwania animacji
    once: true, // tylko raz na wejście
  });
};
